import React from 'react'
import InventoryIcon from '@mui/icons-material/Inventory'
import CheckIcon from '@mui/icons-material/Check'
import NotificationsIcon from '@mui/icons-material/Notifications'
import VerifiedIcon from '@mui/icons-material/Verified'
import CancelIcon from '@mui/icons-material/Cancel'
import DeleteIcon from '@mui/icons-material/Delete'

interface IOwnProps{
    type: string
}

const IconHistory:React.FC<IOwnProps> = ({ type }) => {
  let icon
  switch (Number(type)) {
    case 0:
      // deleted
      icon = <DeleteIcon />
      break
    case 1:
      // used
      icon = <CheckIcon />
      break
    case 2:
      // request
      icon = <NotificationsIcon />
      break
    case 3:
      // requestDone
      icon = <VerifiedIcon />
      break
    case 4:
      // requestCanceled
      icon = <CancelIcon />
      break
    default:
      // load
      icon = <InventoryIcon />
      break
  }
  return icon
}

export default IconHistory
